<template>
  <div>
    <v-tabs v-model="typePromotionSelected" background-color="transparent" grow>
      <v-tab
        v-for="(typePromotion, index) in typePromotions"
        :key="`${typePromotion}-${index}`"
        class="d-flex flex-column"
      >
        <v-icon class="mb-1" size="22">{{ typePromotion.icon }}</v-icon>
        <span>{{ typePromotion.name }}</span>
      </v-tab>
    </v-tabs>

    <v-radio-group v-model="promotions.selected" class="mt-6">
      <div
        v-for="(promotion, i) in promotionsByTab"
        :key="promotion.id"
        class="d-flex justify-space-between"
        :class="i >= 1 ? 'mt-3' : ''"
      >
        <div style="width: 100%">
          <v-radio :value="i" color="primary">
            <template v-slot:label>
              <div class="d-flex flex-column" style="width: 100%">
                <div
                  v-if="promotion.withPromotionCode"
                  class="d-flex align-center"
                  style="width: 100%"
                >
                  <v-text-field
                    v-model="promotion.promotionCode"
                    :label="$t('promoCode')"
                    ref="promotionCode"
                    @input="
                      $emit('updatePromotionCode', promotion.promotionCode)
                    "
                    outlined
                    class="grey--text"
                    hide-details="auto"
                    clearable
                    dense
                    @keyup="onKeyUp(promotion)"
                    :disabled="promotions.selected !== i"
                    :loading="promotion.message.loading"
                  ></v-text-field>

                  <div v-if="promotion.message.type === 'success'">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          v-on="on"
                          class="ml-2"
                          @click.stop.prevent="
                            showPromotionDetail(
                              promotion,
                              promotion.promotionCode
                            )
                          "
                          color="blue"
                          small
                        >
                          mdi-information
                        </v-icon>
                      </template>
                      <span>
                        {{ $t("promotionRules") }}
                      </span>
                    </v-tooltip>
                  </div>
                </div>

                <div class="d-flex flex-column">
                  <div class="d-flex flex-column">
                    <div class="text-body-2">
                      <span v-if="promotion.type_promo === $t('none')">
                        {{ promotion.type_promo }}
                      </span>
                      <span v-else>
                        {{ promotion.titulo }}
                      </span>
                    </div>
                    <!-- Promotion feedback -->
                    <div
                      class="caption"
                      v-if="
                        promotions.selected === i &&
                          promotion.message.type !== '' &&
                          (promotion.withPromotionCode
                            ? !!promotion.promotionCode
                            : true)
                      "
                    >
                      <span
                        class="ma-0 pa-0"
                        :class="`${promotion.message.type}--text`"
                      >
                        <strong>
                          {{ promotion.message.text }}
                        </strong>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </v-radio>
        </div>
        <div
          v-if="
            promotion.type_promo != $t('none') && !promotion.withPromotionCode
          "
        >
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                class="ml-1"
                @click.stop.prevent="showPromotionDetail(promotion)"
                color="blue"
                small
              >
                mdi-information
              </v-icon>
            </template>
            <span>
              {{ $t("promotionRules") }}
            </span>
          </v-tooltip>
        </div>
      </div>
    </v-radio-group>
  </div>
</template>

<script>
let lastPromotionSelected = {};

export default {
  props: ["promotions", "hiddenPromotions", "slideModel"],

  data: () => ({
    dontEmit: false,
    typePromotionSelected: 0, // (0 - Sport | 1 - Casino)
  }),

  created() {
    const promotionStatus = localStorage.getItem("promotionStatus");
    if (promotionStatus) {
      localStorage.removeItem("promotionStatus");

      const json = JSON.parse(promotionStatus);
      // this.dontEmit = true;
      // this.promotionCode = json.code;
      this.promotions.items = this.promotions.items.map((promotion) => {
        if (promotion.withPromotionCode) {
          return {
            ...promotion,
            promotionCode: json.code,
            message: json.message,
          };
        }

        return promotion;
      });
    }

    // Ao abrir dialog de depósito reset radio buttons se não tiver aberto a
    // dialog de regras
    const lastPromotionSelectedStorage = localStorage.getItem(
      "lastPromotionSelected"
    );

    if (lastPromotionSelectedStorage) {
      localStorage.removeItem("lastPromotionSelected");

      const json = JSON.parse(lastPromotionSelectedStorage);
      lastPromotionSelected = json;

      this.typePromotionSelected = json.tabSelected;
      this.promotions.selected = json.promoSelected;
    } else {
      this.promotions.selected = 0;
    }

    // Ao abrir dialog de depósito pela listagem de promoções em promoções
    // Selecionar campanha ou promoção a partir do código
    const promotionCodeFromPromotions = localStorage.getItem(
      "depositPromotionCodeFromPromotions"
    );

    if (promotionCodeFromPromotions) {
      localStorage.removeItem("depositPromotionCodeFromPromotions");

      const promoCode = JSON.parse(promotionCodeFromPromotions);
      const productTypeCurrentPromo =
        this.promotions.items.find((promo) => promo.code_promo == promoCode)
          .product_type == "sportbook"
          ? 0
          : 1;

      this.typePromotionSelected = productTypeCurrentPromo;

      const findIndexByPromo = this.promotionsByTab.findIndex(
        (campaign) =>
          campaign.code_promo &&
          campaign.code_promo.toUpperCase() === promoCode.toUpperCase()
      );

      if (productTypeCurrentPromo == 1) {
        lastPromotionSelected = {
          tabSelected: productTypeCurrentPromo,
          promoSelected: findIndexByPromo,
        };
      } else {
        this.promotions.selected = findIndexByPromo;
      }
    }
  },

  computed: {
    typePromotions() {
      return [
        {
          name: this.$t("sports"),
          icon: "mdi-soccer",
        },
        {
          name: this.$t("casino"),
          icon: "mdi-slot-machine-outline",
        },
      ];
    },
    promotionsByTab() {
      return this.promotions.items.filter((promo) => {
        if (promo.noPromotionOption || promo.withPromotionCode) {
          return promo;
        } else if (
          this.typePromotionSelected == 1 &&
          promo.product_type == "casino"
        ) {
          return promo.product_type == "casino";
        } else if (
          this.typePromotionSelected == 0 &&
          promo.product_type != "casino"
        ) {
          return promo;
        }
      });
    },
  },

  watch: {
    typePromotionSelected(typePromotionSelected) {
      this.$emit("clearBonusValue");
      this.$emit("clearPromotionCode");

      // Ao mudar de tab reset radio buttons
      this.promotions.tabSelected = typePromotionSelected;

      if (lastPromotionSelected && lastPromotionSelected.tabSelected == 1) {
        this.promotions.selected = lastPromotionSelected.promoSelected;

        lastPromotionSelected = {};
      } else {
        this.promotions.selected = 0;

        lastPromotionSelected = {};
      }
    },
    slideModel() {
      // Resetar tab e promoção selecionado ao mudar de Gateway de pagamento
      this.promotions.selected = 0;
    },
  },

  methods: {
    showPromotionDetail(promotion, promotionCode = false) {
      if (promotionCode) {
        localStorage.setItem(
          "promotionStatus",
          JSON.stringify({
            ...promotion,
            code: promotionCode,
          })
        );

        this.$emit(
          "showPromotionDetail",
          this.hiddenPromotions.find(
            (promotion) =>
              promotion.code_promo &&
              promotion.code_promo.toUpperCase() === promotionCode.toUpperCase()
          ) ||
            this.promotions.items.find(
              (promotion) =>
                promotion.code_promo &&
                promotion.code_promo.toUpperCase() ===
                  promotionCode.toUpperCase()
            )
        );
      } else {
        if (this.promotionCode) {
          localStorage.setItem(
            "promotionStatus",
            JSON.stringify({
              ...this.promotions.items.find(
                (promotion) => promotion.withPromotionCode
              ),
              code: this.promotionCode,
            })
          );
        }

        this.$emit("showPromotionDetail", promotion);
      }

      localStorage.setItem(
        "lastPromotionSelected",
        JSON.stringify({
          tabSelected: this.typePromotionSelected,
          promoSelected: this.promotions.selected,
        })
      );
    },
    transformTypePromo(type_promo) {
      const map = {
        "1ºdeposito": this.$t("firstDepositPromotion"),
        deposito: this.$t("depositPromotion"),
      };

      return map[type_promo] || null;
    },

    onKeyUp() {
      this.promotions.items = this.promotions.items.map((promotion) => {
        if (promotion.withPromotionCode) {
          return {
            ...promotion,
            promotionCode: promotion.promotionCode
              .toUpperCase()
              // Tira espaço em branco
              .replace(/\s/g, ""),
          };
        }
        return promotion;
      });
    },

    // n esta sendo usada
    clearPromotionCode() {
      this.promotions.items = this.promotions.items.map((promotion) => {
        if (promotion.withPromotionCode) {
          return {
            ...promotion,
            promotionCode: "",
          };
        }

        return promotion;
      });
    },
    // n esta sendo usada
    focusOnPromotionCode() {
      setTimeout(() => {
        this.$refs.promotionCode[0].focus();
      });
    },
  },
  // watch: {
  //   promotionCode(code) {
  //     if (this.dontEmit) {
  //       this.dontEmit = false;
  //       return;
  //     }

  //     this.$emit("promotionCodeUpdate", code);
  //   },
  // },
};
</script>
